import React, { useState,useEffect,useRef } from "react"
import { ImCross } from "react-icons/im"
import styles from "./messageBox.module.css"
import {IoIosArrowDown,IoIosArrowUp} from 'react-icons/io'
import {BsThreeDotsVertical} from 'react-icons/bs'


import ChatAction from "./chatAction"
import MoreOption from "./moreOption"
const MeassageBox =(prosp)=>{

    const [hide,setHide]=useState(true);
    const[moreOption,setMoreOption]=useState(false)

    const myRef = useRef();

    const handleClickOutside = e => {
        if (!myRef.current.contains(e.target)) {
           
            setHide(true)
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });
    return(
        <div ref={myRef} style={{
            zIndex:2,
            position:"fixed",
            right:"7%",
            transition:"bottom .5s",
            bottom:hide?"-240px":"0px",
        }}>
            <div  className={styles.meassageBoxContainer}>
                <div className={styles.titleCon}>
                    <img src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg" className={styles.img}/>
                  
                <div className={styles.title}>user name </div>
                
                {false?
                    <IoIosArrowUp onClick={()=>setHide(!hide)} className={styles.hideicon}/>:                
                <IoIosArrowDown onClick={()=>setHide(!hide)} className={styles.hideicon}/>}
                <BsThreeDotsVertical onClick={()=>setMoreOption(!moreOption)} className={styles.hideicon}/>
                 <ImCross className={styles.crossicon}/>
                
                </div>
                <br/>
                {moreOption?<MoreOption/>:""}
    
                <ChatAction/>
            </div>
            
            </div>
    )
}

export default MeassageBox;